import { FieldItem } from "../../../types";
import { Label } from "../label";

export const AppointmentFieldWrapper = ({
  children,
  id,
  error,
  errorId,
  field,
}: {
  children: React.ReactNode;
  id: string;
  error?: string;
  errorId: string;
  field: FieldItem;
}) => (
  <div
    className="rounded border border-neutral-100 print:break-inside-avoid"
    id={id}
    aria-invalid={!!error}
    aria-errormessage={error ? errorId : undefined}
    data-testid={`appointment-field-wrapper-${field.uri}`}
  >
    <div className="px-[2.4rem] border-b border-neutral-100">
      <div className="w-fit py-[1.6rem] border-b-2 border-neutral-500">
        <Label {...field} />
      </div>
    </div>
    {children}
  </div>
);
